module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"business_hours":"Business Hours"}}')
  delete Component.options._Ctor
}
